import { toast } from "react-toastify";


const validateEmail = (email) => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(String(email).toLowerCase());
};
export const handleChange = async (value) => {
  try {
    if (value.trim() === "") {
      return "Please enter your email address.";
    } else if (!validateEmail(value)) {
      return "Please enter a valid email address.";
    } else {
      return "";
    }
  } catch (error) {
     // console.log("error");
  }
};

export const ShowToast = async (type, value) => {
  if (type == 1) {
    toast.success(value);
  } else if (type == 0) {

    toast.error(value);
  }
};

export const formatDate = (timestamp) => {
  const date = new Date(timestamp);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options);
};

export const validatePassword = (password) => {
  const minLength = 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  if (password.length < minLength) {
    return `Password must be at least ${minLength} characters long`;
  }
  if (!hasUpperCase) {
    return "Password must contain at least one uppercase letter";
  }
  if (!hasLowerCase) {
    return "Password must contain at least one lowercase letter";
  }
  if (!hasNumber) {
    return "Password must contain at least one number";
  }
  if (!hasSpecialChar) {
    return "Password must contain at least one special character";
  }
  return "";
};
